import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import DateTimePicker from "@react-native-community/datetimepicker";
import { useFocusEffect, useRoute } from "@react-navigation/core";
import dayjs from "dayjs";
import * as DocumentPicker from "expo-document-picker";
import * as FileSystem from "expo-file-system";
import {
	Actionsheet,
	Box,
	Button,
	FormControl,
	Icon,
	IconButton,
	Input,
	InputLeftAddon,
	ScrollView,
	Select,
	Stack,
	Text,
	useDisclose,
	useMediaQuery,
	useTheme,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, Image, Platform, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { useDispatch, useSelector } from "react-redux";
import checkCardStatus from "../../common/checkCardStatus";
import checkLinkedCard from "../../common/checkLinkedCard";
// API
import disputeClaim from "../../common/disputeClaim";
import requestCardActivationOTP from "../../common/requestCardActivationOTP";
import submitCardActivation from "../../common/submitCardActivation";
import submitCardCancellation from "../../common/submitCardCancellation";
import AppCamera from "../../components/camera/AppCamera";
import AppScanCamera from "../../components/camera/AppScanCamera";
import ErrorToast from "../../components/ErrorToast";
import InfoToast from "../../components/InfoToast";
import Loader from "../../components/Loader";
import SuccessToast from "../../components/SuccessToast";
import { getCardBalance } from "../../redux/slices/CardBalanceSlice";
import Constants from "../../utils/Constants";
import { isWeb } from "../../utils/utils";

const CardActivation = ({ navigation, route }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showOTP, setShowOTP] = useState(false);
	const [CardActivation, setCardActivation] = useState({});
	const dispatch = useDispatch();

	const Auth = useSelector((state) => state.Login.Auth);
	const page = useSelector((state) => state.Page.Pages);
	const isPageLoading = useSelector((state) => state.Page.loading);
	const HasLinkedCard = useSelector((state) => state.cardBalance.hasLinkedCard);

	useEffect(async () => {
		dispatch(getCardBalance());
	}, [route]);

	const handleCardActivationSubmit = async () => {
		try {
			if (showOTP === false) {
				let params = {
					storemember_guid: Auth.storemember_guid,
					type: HasLinkedCard ? "cardcancel" : "cardactivate",
				};

				setIsSubmitting(true);

				let results = await requestCardActivationOTP(
					Auth.session_token,
					params
				);

				setIsSubmitting(false);
				setCardActivation({ ...CardActivation, otp: "" });
				setShowOTP(true);
			} else {
				setIsSubmitting(true);

				if (HasLinkedCard) {
					let params = {
						storemember_guid: Auth.storemember_guid,
						reason: "lost",
						...CardActivation,
					};

					let results = await submitCardCancellation(
						Auth.session_token,
						params
					);
				} else {
					let params = {
						storemember_guid: Auth.storemember_guid,
						...CardActivation,
					};

					let results = await submitCardActivation(Auth.session_token, params);
				}

				setIsSubmitting(false);
				setShowOTP(false);
				SuccessToast(
					HasLinkedCard
						? "Card cancelled successfully"
						: "Card activated successfully",
					"Manage Card"
				);
				setCardActivation({});
				navigation.navigate("Main Menu");
			}
		} catch (error) {
			setIsSubmitting(false);
			setShowOTP(false);
			console.log(error.message);
			if (error.data?.error) {
				ErrorToast(error.data.error);
			} else {
				ErrorToast(error.message);
			}
		}
	};

	const onChange = (value, label = null) => {
		if (value?.target?.value) {
			if (
				value.target.value.replace(/\D+/g, "").length > 4 &&
				label === "card_number_last4"
			)
				return;

			setCardActivation({
				...CardActivation,
				[label]: value.target.value.replace(/\D+/g, ""),
			});
		} else {
			if (value.replace(/\D+/g, "").length > 4 && label === "card_number_last4")
				return;

			setCardActivation({
				...CardActivation,
				[label]: value.replace(/\D+/g, ""),
			});
		}
	};

	const componentGenerator = (control) => {
		if (control.componenttype_name === "INPUT") {
			return (
				<>
					{control.datatype_label === "OTP" ? (
						<>
							{showOTP && (
								<View key={control.datatype_label}>
									<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
									<FormControl.HelperText _text={{ fontSize: "xs" }}>
										{control.sitepagecomponent_meta.input_notice}
									</FormControl.HelperText>
									<Input
										// isDisabled={control.datatype_label === "OTP" ? showOTP : false}
										borderWidth={2}
										onChangeText={(value) =>
											onChange(value, control.datatype_name)
										}
										placeholder={`${control.sitepagecomponent_meta.placeholder}`}
										label={`${control.datatype_label}`}
										value={CardActivation[control.datatype_name]}
										// InputLeftElement={
										// 	<InputLeftAddon
										// 		children={control.sitepagecomponent_meta.leftplaceholder}
										// 	/>
										// }
									/>
								</View>
							)}
						</>
					) : (
						<View key={control.datatype_label}>
							<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
							<FormControl.HelperText _text={{ fontSize: "xs" }}>
								{control.sitepagecomponent_meta.input_notice}
							</FormControl.HelperText>
							<Input
								isDisabled={
									control.datatype_name === "card_number_last4"
										? HasLinkedCard
										: false
								}
								borderWidth={2}
								maxLength={
									control.datatype_label === "card_number_last4" ? 4 : 100
								}
								onChangeText={(value) => onChange(value, control.datatype_name)}
								placeholder={`${control.sitepagecomponent_meta.placeholder}`}
								label={`${control.datatype_label}`}
								value={CardActivation[control.datatype_name]}
								// InputLeftElement={
								// 	<InputLeftAddon
								// 		children={control.sitepagecomponent_meta.leftplaceholder}
								// 	/>
								// }
							/>
						</View>
					)}
				</>
			);
		} else if (control.componenttype_name === "SELECT") {
			return (
				<View>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					<Select
						borderWidth={2}
						onValueChange={(value) => onChange(value, control.datatype_name)}
						name={`${control.datatype_label}`}
						selectedValue={CardActivation[control.datatype_name]}
						placeholder={` Select ${control.datatype_label}`}
					>
						{control?.datatype_metadata?.validations?.select_options?.map(
							(item, index) => {
								return (
									<Select.Item
										key={index}
										label={Object.values(item)[0]}
										value={Object.keys(item)[0]}
									/>
								);
							}
						)}
					</Select>
				</View>
			);
		} else if (control.componenttype_name === "DATE") {
			return (
				<View key={control.sitepagecomponent_guid}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					{isWeb() ? (
						<Application theme={theme}>
							<DatePicker
								error={` `}
								placeholder={`${control.datatype_label}`}
								onChange={(value) =>
									onChange(
										dayjs(value).format("YYYY-MM-DD"),
										control.datatype_name
									)
								}
								value={
									CardActivation[control.datatype_name]
										? new Date(CardActivation[control.datatype_name])
										: new Date()
								}
								placehplaceholder={`${control.datatype_label}`}
								formatStyle="medium"
								maxDate={new Date()}
								locale="en-ZA"
								style={{
									fontFamily: "NotoSansRegular",
									fontSize: 10,
								}}
							/>
						</Application>
					) : (
						<>
							<Input
								borderWidth={2}
								onPressIn={() => setShowDate(true)}
								onChangeText={(value) => onChange(value, control.datatype_name)}
								showSoftInputOnFocus={false}
								value={
									CardActivation.find(
										(val) => val.datatype_name === control.datatype_name
									)?.data_text
								}
								type="text"
								InputRightElement={
									<IconButton
										size="sm"
										onPress={() => setShowDate(true)}
										_icon={{
											as: Ionicons,
											name: "calendar",
											color: "primary.500",
											size: "sm",
										}}
									></IconButton>
								}
								// isDisabled={true}
								placeholder={`${control.datatype_label} format YYYY-MM-DD`}
							/>
							{showDate && (
								<DateTimePicker
									maximumDate={new Date()}
									mode="date"
									is24Hour={true}
									display="default"
									value={
										CardActivation[control.datatype_name]
											? new Date(CardActivation[control.datatype_name])
											: new Date()
									}
									onChange={(event, value) => {
										onChange(value, control.datatype_name);
										setShowDate(false);
									}}
								/>
							)}
						</>
					)}
				</View>
			);
		} else if (control.componenttype_name === "NUMBER") {
			return (
				<View key={control.datatype_label}>
					<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
					<Input
						keyboardType="number-pad"
						borderWidth={2}
						onChangeText={(value) => onChange(value, control.datatype_name)}
						placeholder={`${control.datatype_label}`}
						label={`${control.datatype_label}`}
						value={CardActivation[control.datatype_name]}
					/>
				</View>
			);
		} else if (control.componenttype_name === "BUTTON") {
			return (
				<View key={control.datatype_label}>
					<Button
						onPress={handleCardActivationSubmit}
						isLoading={isSubmitting}
						isLoadingText="Submitting"
						colorScheme={HasLinkedCard ? "danger" : "primary"}
						variant={isSubmitting ? "outline" : "solid"}
						style={
							isDesktopOrLaptop[0]
								? {
										marginLeft: "auto",
								  }
								: {}
						}
					>
						{HasLinkedCard
							? `${control.sitepagecomponent_meta.altLabel}`
							: `${control.sitepagecomponent_meta.label}`}
					</Button>
				</View>
			);
		}
	};

	return (
		<>
			{isPageLoading ? (
				<Loader />
			) : (
				<ScrollView>
					<Box bg="#fff" padding="20px" borderRadius="5px" flex="3">
						<FormControl isRequired>
							<Stack mx="3" space={2.5}>
								<View
									style={{
										backgroundColor: HasLinkedCard ? "#FFCCCB" : "#DEF0DD",
										padding: 5,
										borderRadius: 5,
									}}
								>
									{HasLinkedCard ? (
										<>
											<Text fontSize={12} fontWeight="900">
												To cancel your card please enter the sequence number
												found the barcode on your CIP card letter.
											</Text>
											<Text fontSize={12} marginTop={2} fontWeight="900">
												Please note by cancelling your card you may be subject
												to a replacement card charge.
											</Text>
										</>
									) : (
										<Text fontSize={12} fontWeight="900">
											To activate your card please enter the last 4 digits of
											your card number as well as the sequence number found the
											barcode on your CIP card letter.
										</Text>
									)}

									<Text fontSize={12} marginTop={5} fontWeight="900">
										Please keep your cellphone handy to enter the OTP received
										via SMS
									</Text>
								</View>
								{page[0]?.children_components.map((control, index) =>
									componentGenerator(control)
								)}
							</Stack>
						</FormControl>
					</Box>
				</ScrollView>
			)}
		</>
	);
};

export default CardActivation;
